import { forwardRef, useImperativeHandle } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { Button } from "@design-system/Button/Button";
import { Form } from "@design-system/Form/Form";
import { TextField } from "@design-system/TextField/TextField";

export type ClientEmployeeFilterFormValues = {
  nameSearch: string;
  emailSearch: string;
};

export type ClientEmployeeFilterFormRef = {
  getCurrentValues: () => ClientEmployeeFilterFormValues;
};

type Props = {
  values: ClientEmployeeFilterFormValues;
  onFilterChange: SubmitHandler<ClientEmployeeFilterFormValues>;
  errorsAPI?: unknown;
};

export const ClientEmployeeFilterForm = forwardRef<
  ClientEmployeeFilterFormRef,
  Props
>(({ values, onFilterChange, errorsAPI }, ref) => {
  const { handleSubmit, setValue, watch, getValues } =
    useForm<ClientEmployeeFilterFormValues>({
      values: {
        nameSearch: values.nameSearch ?? "",
        emailSearch: values.emailSearch ?? "",
      },
    });

  useImperativeHandle(ref, () => ({
    getCurrentValues: () => getValues(),
  }));

  const nameSearch = watch("nameSearch");
  const emailSearch = watch("emailSearch");

  return (
    <Form onSubmit={handleSubmit(onFilterChange)} errorsAPI={errorsAPI as Record<string, string> | undefined}>
      <TextField
        placeholder="Search by name..."
        value={nameSearch}
        onChange={(e) =>
          setValue("nameSearch", e.target.value, { shouldDirty: true })
        }
      />
      <TextField
        placeholder="Search by email..."
        value={emailSearch}
        onChange={(e) =>
          setValue("emailSearch", e.target.value, { shouldDirty: true })
        }
      />
      {/* Hidden submit button to enable Enter key submission */}
      <Button type="submit" style={{ display: "none" }} />
    </Form>
  );
});